import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Toaster } from 'sonner';
import { useAuth } from '@/context/AuthContext';
import { moduleForPath } from '@/lib/permissions';
import { LockKey } from '@phosphor-icons/react';
import SerialLookup from '@/components/SerialLookup';

function AccessDenied() {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center" data-testid="access-denied">
      <LockKey size={48} className="text-[#64748B] mb-4" />
      <h2 className="text-xl font-semibold text-[#0F172A] mb-2">Access restricted</h2>
      <p className="text-sm text-[#64748B] max-w-md">
        You don't have permission to view this page. Ask an administrator to grant access
        from Roles &amp; Permissions if you need it.
      </p>
    </div>
  );
}

export default function MainLayout() {
  const location = useLocation();
  const { can } = useAuth();
  const allowed = can(moduleForPath(location.pathname), 'view');
  return (
    <div className="app-container" data-testid="main-layout">
      <Sidebar />
      <main className="main-content">
        <div className="sticky top-0 z-30 flex items-center justify-end gap-3 px-6 py-2 bg-white/90 backdrop-blur border-b border-[#E2E8F0]" data-testid="global-topbar">
          <span className="text-[11px] text-[#94A3B8] hidden sm:inline">Trace any device →</span>
          <SerialLookup />
        </div>
        <div className="flex-1">
          {allowed ? <Outlet /> : <AccessDenied />}
        </div>
        <footer className="app-footer flex flex-col sm:flex-row items-center justify-between gap-2" data-testid="app-footer">
          <p className="text-xs text-[#64748B]">
            © {new Date().getFullYear()} Fintexa ERP · HearClear Clinic Operations Platform
          </p>
          <div className="flex items-center gap-4 text-xs text-[#64748B]">
            <span className="hover:text-[#0F4C81] transition-colors cursor-default">Privacy</span>
            <span className="hover:text-[#0F4C81] transition-colors cursor-default">Terms</span>
            <span className="hover:text-[#0F4C81] transition-colors cursor-default">Support</span>
            <span className="text-[#94A3B8]">v4.2</span>
          </div>
        </footer>
      </main>
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: '#FFFFFF',
            border: '1px solid #E2E8F0',
            color: '#0F172A',
          },
        }}
      />
    </div>
  );
}
